import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { formatNumber } from '../../helpers/numbers'

import { clearChoicesInterests, getChoicesInterests } from '../../modules/actions/choices'
import { selectedFacebookAdAccountSelector } from '../../modules/selectors/adAccounts'
import { choicesInterestsSelector } from '../../modules/selectors/choices'

export const useLoadFacebookInterests = () => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const interests = useSelector(choicesInterestsSelector)

  const formattedInterests = useMemo(
    () =>
      interests &&
      interests.map(item => {
        // adds a label to the results showing the audience size
        const description = `${formatNumber(item.audience_size_lower_bound, { min: 0, max: 0 })} - ${formatNumber(
          item.audience_size_upper_bound,
          { min: 0, max: 0 }
        )} ${t('people')}`

        return { value: item.id, label: item.name, description: description }
      }),
    [interests, t]
  )

  const searchInterests = useCallback(
    searchValue => {
      if (searchValue) {
        dispatch(getChoicesInterests({ search: searchValue, account: selectedAdAccountId }))
      } else {
        dispatch(clearChoicesInterests())
      }
    },
    [dispatch, selectedAdAccountId]
  )

  return useMemo(() => ({ formattedInterests, searchInterests }), [formattedInterests, searchInterests])
}
